import {
  ContextualTipId,
  useContextualTip,
  useContextualTipContext,
} from '@resistapp/client/contexts/contextual-tip-context';
import { useMapContext } from '@resistapp/client/contexts/map-context';
import { useOverviewContext } from '@resistapp/client/contexts/use-overview-context/use-overview-context';
import { useEffect, useRef } from 'react';
import { ContextualTip } from './contextual-tip';

export function AreaClickTip() {
  // Reference element at which to anchor the tooltip
  const anchorRef = useRef<HTMLDivElement>(null);

  // Determine current UI state
  const { activeMapSource } = useMapContext();
  const { metricMode } = useOverviewContext();

  // Tip visibility / interactions
  const { setTipEnabled } = useContextualTipContext();
  const { visible, message, dismiss, animationDelay, showDismiss } = useContextualTip(
    ContextualTipId.MAP_CLICK_AREA,
    metricMode,
  );

  // Enable the tip only when areas (colored regions) are active
  const areasActive = !!activeMapSource;

  useEffect(() => {
    setTipEnabled(ContextualTipId.MAP_CLICK_AREA, areasActive);
  }, [areasActive, setTipEnabled]);

  if (!visible) {
    return null;
  }

  // Note: Because the anchor is positioned absolutely inside the map container
  // (which has position: relative), we can simply place it at 50%/50% to
  // approximate the center of the current view.
  return (
    <>
      <div
        ref={anchorRef}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          // Zero-sized element purely for anchoring
          width: 0,
          height: 0,
        }}
      />
      <ContextualTip
        anchorRef={anchorRef}
        message={message || ''}
        onDismiss={dismiss}
        placement="none"
        animationDelay={animationDelay}
        showDismiss={showDismiss}
      />
    </>
  );
}
